// extracted by mini-css-extract-plugin
export var closeButton = "_w-5";
export var container = "_w-0";
export var contentContainer = "_w-1";
export var desktop = "_w-2";
export var fullModalImage = "_w-6";
export var mobile = "_w-3";
export var withImage = "_w-4";